<iframe #frame title="Acompanhamento Diário" src="https://app.powerbi.com/view?r=eyJrIjoiOWFmY2NiM2ItY2MzNi00NDBlLTgzZDctNTYwMTUzYzUwOWIyIiwidCI6ImZkOTliM2EzLWUzODctNGE1MC05NTRhLTUzMDc5NGY5NWYwMCJ9" allowFullScreen="true"></iframe>
